var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScribeLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254 199",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF5A67",
    transform: "rotate(-15 127 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 206,
    height: 42,
    rx: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 86,
    width: 246,
    height: 42,
    rx: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 156,
    width: 106,
    height: 42,
    rx: 21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribeLogo2);
export default __webpack_public_path__ + "static/media/scribeLogo2.27e010804fdfafac57cd53f80d1ed9f4.svg";
export { ForwardRef as ReactComponent };